import { AxiosError } from 'axios'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom-original'

import { ContentPageLayout } from '@/layout/components/content-page-layout/ContentPageLayout'
import { DeeplinkNotFound } from '@/modules/shared/components/deeplink-not-found/DeeplinkNotFound'
import { ErrorLayout } from '@/modules/shared/components/error-layout/ErrorLayout'
import { Loader } from '@/modules/shared/components/loader/Loader'
import { useCommunicationDocument, useSynopsDocument } from '../../hooks/useCommunicationDocuments'
import { PdfPreview } from '../pdf-preview/PdfPreview'

export const DocumentPreview = () => {
  const { fileId } = useParams()
  const [searchParameters] = useSearchParams()

  const fileName = searchParameters?.get('fileName') ?? 'Document'
  const source = searchParameters?.get('source') ?? 'communication'
  const navigate = useNavigate()

  const communicationDocument = useCommunicationDocument(source === 'communication' ? fileId : undefined)
  const messageDocument = useSynopsDocument(source === 'message' ? fileId : undefined)

  const { data: file, isLoading, error } = source === 'message' ? messageDocument : communicationDocument

  if (isLoading) {
    return (
      <ContentPageLayout noPadding animationkey='documents-preview'>
        <Loader />
      </ContentPageLayout>
    )
  }

  // 404 = not found, 403 = deleted
  const isDocumentNotAvailable =
    error instanceof AxiosError && (error.response?.status === 404 || error.response?.status === 403)

  if (isDocumentNotAvailable) {
    return <DeeplinkNotFound origin='documents' />
  }

  if (error) {
    return (
      <ContentPageLayout noPadding animationkey='documents-preview'>
        <ErrorLayout
          title='Fout bij het laden van het document'
          message='Er is een fout opgetreden bij het laden van het document. Probeer het later opnieuw.'
        />
      </ContentPageLayout>
    )
  }

  if (!file?.inhoud) {
    return <DeeplinkNotFound origin='documents' />
  }

  return (
    <ContentPageLayout noPadding animationkey='documents-preview'>
      <PdfPreview downloadEnabled filename={fileName} preview={file?.inhoud} onClose={() => navigate(-1)} />
    </ContentPageLayout>
  )
}
